import { render, staticRenderFns } from "./OrigenDestino.vue?vue&type=template&id=0014ec77&lang=pug"
import script from "./OrigenDestino.vue?vue&type=script&lang=js"
export * from "./OrigenDestino.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports